import noUiSlider from 'nouislider';
import { trans } from '../../functions';
import { collapseFilters } from './index/helpers';

export default {
    props: [
        'initialQuery',
        'initialBrandName',
        'initialBrandBanner',
        'initialBrandSlug',
        'initialCategoryName',
        'initialCategoryBanner',
        'initialCategorySlug',
        'initialTagName',
        'initialTagSlug',
        'initialAttribute',
        'maxPrice',
        'minPrice',
        'initialSort',
        'initialPerPage',
        'initialPage',
        'initialViewMode',
    ],

    data() {
        return {
            fetchingProducts: false,
            products: { data: [] },
            attributeFilters: [],
            brandid: [],
            brandBanner: this.initialBrandBanner,
            categoryName: this.initialCategoryName,
            categoryBanner: this.initialCategoryBanner,
            viewMode: this.initialViewMode,
            queryParams: {
                query: this.initialQuery,
                brand: this.initialBrandSlug,
                category: this.initialCategorySlug,
                tag: this.initialTagSlug,
                attribute: this.initialAttribute,
                categoriesFiltres: [],
                marquesFiltres: [],
                fromPrice: this.minPrice,
                toPrice: this.maxPrice,
                sort: this.initialSort,
                perPage: this.initialPerPage,
                page: this.initialPage,
                slug: 'ventes_flash',
          
                   
            },
           
            categories: [] ,
            marques: [],
            affichageMarque:0,
            keywordQuery: '',

        };
    },

    computed: {
        emptyProducts() {
            return this.products.data.length === 0;
        },

        totalPage() {
            return Math.ceil(this.products.total / this.queryParams.perPage);
        },

        showingResults() {
            if (this.emptyProducts) {
                return;
            }

            return trans('storefront::products.showing_results', {
                from: this.products.from,
                to: this.products.to,
                total: this.products.total,              
            });
        },
    },

    mounted() {
        this.addEventListeners();
        this.initPriceFilter();
        this.fetchProducts();
    },

    methods: {

        handleKeywordKeyUp() {
            const keywordValue = this.keywordQuery;
            this.queryParams.query = keywordValue;
           
            this.fetchProducts({ updateAttributeFilters: true });
        },


        addEventListeners() {
            $(this.$refs.sortSelect).on('change', (e) => {
                this.queryParams.sort = e.currentTarget.value;

                this.fetchProducts();
            });

            $(this.$refs.perPageSelect).on('change', (e) => {
                this.queryParams.perPage = e.currentTarget.value;

                this.fetchProducts();
            });
        },

        initPriceFilter() {
            noUiSlider.create(this.$refs.priceRange, {
                connect: true,
                direction: window.FleetCart.rtl ? 'rtl' : 'ltr',
                start: [this.minPrice, this.maxPrice],
                range: {
                    min: [this.minPrice],
                    max: [this.maxPrice],
                },
            });

            this.$refs.priceRange.noUiSlider.on('update', (values, handle) => {
                let value = Math.round(values[handle]);

                if (handle === 0) {
                    this.queryParams.fromPrice = value;
                } else {
                    this.queryParams.toPrice = value;
                }
            });

            this.$refs.priceRange.noUiSlider.on('change', this.fetchProducts);
        },

        updatePriceRange(fromPrice, toPrice) {
            this.$refs.priceRange.noUiSlider.set([fromPrice, toPrice]);
            this.queryParams.page = 1;

            this.fetchProducts();
        },

        toggleAttributeFilter(slug, value) {
            if (! this.queryParams.attribute.hasOwnProperty(slug)) {
                this.queryParams.attribute[slug] = [];
            }

            if (this.queryParams.attribute[slug].includes(value)) {
                this.queryParams.attribute[slug].splice(
                    this.queryParams.attribute[slug].indexOf(value),
                    1
                );
            } else {
                this.queryParams.attribute[slug].push(value);
            }

            this.fetchProducts({ updateAttributeFilters: false });
        },
        changeCategoryFilter(slug, id) {
            const index = this.queryParams.categoriesFiltres.indexOf(id);
        
            if (index > -1) {
                this.queryParams.categoriesFiltres.splice(index, 1);
            } else {
                this.queryParams.categoriesFiltres.push(id);
            }
            this.queryParams.page = 1;

            this.fetchProducts({ updateAttributeFilters: false });
        },
        changeMarqueFilter(slug,id) {
            const index = this.queryParams.marquesFiltres.indexOf(id);
        
            if (index > -1) {
                this.queryParams.marquesFiltres.splice(index, 1);
            } else {
                this.queryParams.marquesFiltres.push(id);
            }
            this.queryParams.page = 1;

            this.fetchProducts({ updateAttributeFilters: false });
        },

        isFilteredByAttribute(slug, value) {
            if (! this.queryParams.attribute.hasOwnProperty(slug)) {
                return false;
            }

            return this.queryParams.attribute[slug].includes(value);
        },

        changeCategory(category) {
            this.categoryName = category.name;
            this.categoryBanner = category.banner.path;
            this.queryParams.query = null;
            this.queryParams.category = category.slug;
            this.queryParams.attribute = {};
            this.queryParams.page = 1;

            this.fetchProducts();
        },

        changePage(page) {
            this.queryParams.page = page;
 
            const searchResultTop = document.querySelector('.search-result-top');

            if (searchResultTop) {
                searchResultTop.scrollIntoView({ behavior: 'smooth' });
            }

            this.fetchProducts();
        },

        fetchProducts(options = { updateAttributeFilters: true }) {
            this.fetchingProducts = true;

            $.ajax({
                url: route('products.flash', this.queryParams),
            }).then((response) => {
           
                this.products = response.products;
                this.brandid = response.brandsid;
                this.categories = response.categories;
                this.marques = response.marques;
                this.affichageMarque = response.affichageMarque;


                this.$nextTick(() => {
                    collapseFilters();
                });
            }).catch((xhr) => {
                this.$notify(xhr.responseJSON.message);
            }).always(() => {
                this.fetchingProducts = false;
            });
        },
    },
};
